define([
    'backbone',
    'handlebars',
    'modules/common/controls/control'
], (Backbone, Handlebars, Control) => Control.extend({

    binders: {
        value: {
            bind (view, publish) {
                this.callback = function () {
                    publish(view.get());
                };
                view.on('change', this.callback);
            },
            unbind (view) {
                view.off('change', this.callback);
            },
            routine (view, value) {
                view.set(value);
            }
        },
        enabled (view, value) {
            view.setEnabled(Boolean(value));
        },
        toggle (view, value) {
            view.$el.toggle(Boolean(value));
        }
    },

    events: {
        'change input': 'radioChange'
    },

    defaults: _.extend({
        id: 'id',
        text: 'text',
        converter (id) {
            return id;
        }
    }, Control.prototype.defaults),

    initialize () {
        Control.prototype.initialize.apply(this, arguments);
        this.choices = this.options.choices;

        this.listenTo(this.choices, 'reset', this.render);
    },

    render () {
        const items = this.choices instanceof Backbone.Collection ? this.choices.toJSON() : this.choices;
        const options = this.options;
        const name = `radiolist-${this.cid}`;

        this.$el.empty().append(items.map((item) => {
            const input = $('<input>').attr({type: 'radio', name, value: item[options.id]});
            if (item.disabled) {
                input.attr({disabled: 'disabled'});
            }
            return $('<label>').
                addClass('radio').
                toggleClass('inline', Boolean(options.inline)).
                append(input).
                append(item[options.text]);
        }));

        return this;
    },

    get () {
        const converter = this.options.converter;
        return converter(this.$('input:checked').val());
    },

    set (id) {
        if (_.isEmpty(id)) {
            return;
        }
        id = id.toString();
        this.$('input').each(function () {
            $(this).prop('checked', $(this).val() === id);
        });
    },

    setEnabled (enabled) {
        this.$('input').attr('disabled', !enabled);
    },

    radioChange () {
        this.trigger('change');
    }

}));
